// TODO: get rid of this file
Array.prototype.remove = function (item) {
    const index = this.indexOf(item)

    if (index > -1) {
        this.splice(index, 1)
    }
}

Array.prototype.insert = function (index, item) {
    this.splice(index, 0, item)
}

Array.prototype.contains = function (item, comparator) {
    if (comparator) {
        return this.find(listItem => comparator(listItem, item))
    } else {
        return this.indexOf(item) > -1
    }
}

Array.prototype.last = function () {
    return this[this.length - 1]
}

Array.prototype.any = function () {
    return this.find(item => item)
}

Array.prototype.safeGet = function (index) {
    const max = this.length - 1

    index = index <= max ? index : max

    index = index >= 0 ? index : 0

    return this[index]
}
